import { Skeleton, Table } from "antd";
import React, { useEffect, useState } from "react";
import Dashboard from "../../Layout/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import { getStores } from "../../../actions/store";
import { formatDate } from "../../../utils/Utils";
import { useNavigate } from "react-router-dom";

const Stores = ({ currentUser }) => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const history = useNavigate();
  const MainData = useSelector((state) => state.stores);
  const data = MainData?.filter((item) => item?._id !== currentUser?.store);

  useEffect(() => {
    setLoading(true);
    dispatch(getStores());
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const columns = [
    {
      key: 1,
      title: "Name",
      dataIndex: "name",
    },
    {
      key: 2,
      title: "Created At",
      dataIndex: "createdAt",
      render: (_, record) => <p>{formatDate(record?.createdAt)}</p>,
    },
    {
      key: 3,
      title: "Currency",
      dataIndex: "currency",
    },
    {
      key: 4,
      title: "Country",
      dataIndex: "country",
    },
    {
      key: 5,
      title: "Status",
      dataIndex: "storeStatus",
    },
    {
      key: 6,
      title: "Updated At",
      dataIndex: "updatedAt",
      render: (_, record) => <p>{formatDate(record?.updatedAt)}</p>,
    },
    {
      key: 7,
      title: "Created At",
      render: (_, record) => <p>{formatDate(record?.createdAt)}</p>,
    },
  ];

  const onRowClick = (id) => {
    history(`/store/${id}`);
  };

  return (
    <Dashboard title="All Stores" superAdmin>
      <div className="flex items-center justify-between">
        <h2 className="text-2xl m-0 font-bold">All Stores</h2>
      </div>
      <div className="bg-white shadow p-4 my-4">
        <Skeleton loading={loading}>
          <Table
            className="cursor-pointer"
            columns={columns}
            scroll={{
              x: 1000,
            }}
            dataSource={data}
            rowKey={(record) => record?._id}
            onRow={(record) => {
              return {
                onClick: () => {
                  onRowClick(record?._id);
                },
              };
            }}
          />
        </Skeleton>
      </div>
    </Dashboard>
  );
};

export default Stores;
